var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('q-img',{attrs:{"src":"img/loading.gif","width":"190px","spinner-color":"primary","spinner-size":"82px"}}),_c('br'),_c('span',{staticClass:"loadingFonts"},[_vm._v("LOADING...!")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }